import { AwesomeEvent, ComponentAPI } from '@philips-emr/tws-core';
import { ClickEventListener } from '@philips-emr/tws-core/lib/component/types';

class HPMSAmountProfessionalsCardAPI extends ComponentAPI<any> {

  @AwesomeEvent
  onAfterSubmitAmountProfessionalsCard = new ClickEventListener();
}

export {
  HPMSAmountProfessionalsCardAPI,
};
